import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { FeatureIconMap, hasFeatureIcon } from "../../search/FeatureIconMap";
import FeatureSubDetail from "../../features/FeatureSubDetail";
import type { LocationFeatureDetails } from "../../../../types/Location";

interface FeatureOptionItemProps {
    feature: string;
    details?: LocationFeatureDetails | null;
    showDetails?: boolean;
}

const FeatureOptionItem = ( {feature, details, showDetails = false}: FeatureOptionItemProps ) => {
    const FeatureIcon = hasFeatureIcon(feature) ? FeatureIconMap[feature] : undefined;
    const name = (
        <Typography className='ss-location-features-item-name'>
            {feature}
        </Typography>
    );

    return (
        <Grid item className={`ss-location-features-option-item${showDetails ? ' ss-location-features-option-item--detailed' : ''}`}>
            {FeatureIcon && <FeatureIcon fontSize={'small'} htmlColor={'#7C8597'} />}
            {showDetails ? (
                <Box className='ss-location-features-item-text'>
                    {name}
                    <FeatureSubDetail feature={feature} details={details} />
                </Box>
            ) : name}
        </Grid>
    )
}

export default FeatureOptionItem;
